// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line no-control-regex, no-misleading-character-class
const rxEscapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;

let gap;
let indent;
let meta;
let rep;

const quote = (string: string): string => {
    rxEscapable.lastIndex = 0;
    return rxEscapable.test(string)
        ? `"${string.replace(rxEscapable, a => {
              const c = meta[a];
              return typeof c === 'string' ? c : `\\u${`0000${a.charCodeAt(0).toString(16)}`.slice(-4)}`;
          })}"`
        : `"${string}"`;
};

const str = (key, holder): string => {
    let i;
    let k;
    let v;
    let length;
    const mind = gap;
    let partial;
    let value = holder[key];

    if (typeof rep === 'function') {
        value = rep.call(holder, key, value);
    }

    switch (typeof value) {
        case 'string':
            return quote(value);
        case 'number':
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line no-restricted-globals
            return isFinite(value) ? String(value) : 'null';
        case 'boolean':
            return String(value);
        case 'object':
            if (!value) {
                return 'null';
            }

            gap += indent;
            partial = [];

            if (Object.prototype.toString.apply(value) === '[object Array]') {
                length = value.length;
                for (i = 0; i < length; i += 1) {
                    partial[i] = str(i, value) || 'null';
                }

                v =
                    partial.length === 0
                        ? '[]'
                        : gap
                        ? `[\n${gap}${partial.join(`,\n${gap}`)}\n${mind}]`
                        : `[${partial.join(',')}]`;
                gap = mind;
                return v;
            }

            if (rep && typeof rep === 'object') {
                length = rep.length;
                for (i = 0; i < length; i += 1) {
                    if (typeof rep[i] === 'string') {
                        k = rep[i];
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (gap ? ': ' : ':') + v);
                        }
                    }
                }
            } else {
                for (k in value) {
                    if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (gap ? ': ' : ':') + v);
                        }
                    }
                }
            }

            v =
                partial.length === 0
                    ? '{}'
                    : gap
                    ? `{\n${gap}${partial.join(`,\n${gap}`)}\n${mind}}`
                    : `{${partial.join(',')}}`;
            gap = mind;
            return v;
        default:
            return '';
    }
};

meta = {
    '\b': '\\b',
    '\t': '\\t',
    '\n': '\\n',
    '\f': '\\f',
    '\r': '\\r',
    '"': '\\"',
    '\\': '\\\\'
};
const stringifyJson = (value: any, replacer?, space?: string | number): string => {
    let i;
    gap = '';
    indent = '';

    if (typeof space === 'number') {
        for (i = 0; i < space; i += 1) {
            indent += ' ';
        }
    } else if (typeof space === 'string') {
        indent = space;
    }

    rep = replacer;
    if (
        replacer &&
        typeof replacer !== 'function' &&
        (typeof replacer !== 'object' || typeof replacer.length !== 'number')
    ) {
        throw new Error('JSON.stringify');
    }

    return str('', { '': value });
};

export default stringifyJson;